import { render, staticRenderFns } from "./closed_modal.vue?vue&type=template&id=4bc871b2&"
import script from "./closed_modal.vue?vue&type=script&lang=js&"
export * from "./closed_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports